import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import boTheme from '@ecp/common/src/style/theme/bo';
import RadioUnstyled, { radioClassNames } from '@ecp/common/src/components/unstyled/input/RadioUnstyled';
import { InputComponent } from '@ecp/common/src/components/radio/Radio';

export const LabelComponent = styled.label`
  height: 28px;
  line-height: 28px;
  color: ${boTheme.color.sub1};
  font-weight: ${boTheme.font.weight.regular};
  font-size: ${boTheme.font.size.small};

  &:before {
    content: '';
    background: ${boTheme.color.sub10};
    border-radius: 100%;
    border: 1px solid ${boTheme.color.sub6};
    display: inline-block;
    width: 20px;
    height: 20px;
    position: relative;
    cursor: pointer;
    text-align: center;
    margin-right: 6px;
    vertical-align: middle;
    box-sizing: border-box;
  }

  ${({ hideControl }) => {
    if (hideControl) {
      return {
        '&:before': {
          display: 'none',
        },
      };
    }
  }}

  &.${radioClassNames.checked} {
    &:hover:before {
      border: 1px solid ${boTheme.color.hover};
      box-shadow: inset 0 0 0 5px ${boTheme.color.hover};
    }

    &:before {
      background-color: ${boTheme.color.sub10};
      border: 1px solid ${boTheme.color.main};
      box-shadow: inset 0 0 0 5px ${boTheme.color.main};
    }
  }

  &.${radioClassNames.checked}.${radioClassNames.disabled} {
    &:before {
      background-color: ${boTheme.color.sub10};
      border: 1px solid ${boTheme.color.sub6};
      box-shadow: inset 0 0 0 5px ${boTheme.color.sub6};
    }
  }

  &.${radioClassNames.disabled} {
    &:before {
      background: ${boTheme.color.sub8};
      border-color: ${boTheme.color.sub6};
    }
  }
`;

export const Radio = React.forwardRef((props, ref) => {
  const { children } = props;
  return (
    <RadioUnstyled ref={ref} inputComponent={InputComponent} labelComponent={LabelComponent} {...props}>
      {children}
    </RadioUnstyled>
  );
});

Radio.displayName = 'Radio';

Radio.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
  children: PropTypes.node,
  disabled: PropTypes.bool,
  hideControl: PropTypes.bool,
};
